import React from 'react';
import { View } from 'react-native';
import Animated, { useAnimatedStyle, SharedValue } from 'react-native-reanimated';
import { styles } from './PhotoPreviewBackground.styles';

type PhotoPreviewBackgroundProps = {
  viewBox: { width: number; height: number; x: number; y: number };
  scaleSV: SharedValue<number>;
  color?: string;
  zIndex: number;
  hasBorder?: boolean;
};

export const PhotoPreviewBackground = ({
  viewBox,
  scaleSV,
  color,
  zIndex,
  hasBorder = false,
}: PhotoPreviewBackgroundProps) => {
  const animatedStyle = useAnimatedStyle(() => {
    const newStyle = {
      width: viewBox.width * scaleSV.value + (hasBorder ? 0 : -2),
      height: viewBox.height * scaleSV.value + (hasBorder ? 0 : -2),
      top: viewBox.y * scaleSV.value + (hasBorder ? 0 : 1),
      left: viewBox.x * scaleSV.value + (hasBorder ? 0 : 1),
      zIndex,
    };

    return newStyle;
  });

  return (
    <Animated.View style={[styles.previewBackgroundContainer, animatedStyle]}>
      <View style={styles.previewShadow} />
      <View style={[styles.previewWhite, { backgroundColor: color }]} />
    </Animated.View>
  );
};
